import {
  GridItem,
  InverseHeader,
  LayoutGrid,
  SwipeableProgressBar,
  SwipeableProvider,
  SwipeableSlider,
  TypographyV3,
} from '@jouzen/ecom-components';
import { useTranslations } from 'next-intl';

import SwipeableNavButtons from '@/app/components/SwipeableNavButtons';

import { sliderContentOreo } from './_data/sliderContent';
import WhyOuraSliderItem from './WhyOuraSliderItem';

const WhyOuraExplore = () => {
  const t = useTranslations();
  const slides = sliderContentOreo();

  return (
    <InverseHeader enter>
      <section className="bg-sandstone-500 pt-16" data-cy="why-oura-explore">
        <LayoutGrid>
          <GridItem colEnd={{ sm: 'main' }} colStart={{ sm: 'main' }}>
            <TypographyV3
              color="light"
              weight="bold"
              Element="h2"
              variant="body-large"
              className="mb-6"
            >
              {t('explore_whats_possible_eyebrow')}
            </TypographyV3>
          </GridItem>
          <GridItem colEnd={{ sm: 'full' }} colStart={{ sm: 'main' }}>
            <SwipeableProvider>
              <div className="flex flex-col-reverse">
                <div className="relative mr-6 max-w-[1312px]">
                  <SwipeableProgressBar variant="light" />
                  <SwipeableNavButtons color="sandstone" />
                </div>
                <SwipeableSlider className="pr-6">
                  {slides.map((slide) => (
                    <WhyOuraSliderItem key={slide.id} slide={slide} />
                  ))}
                </SwipeableSlider>
              </div>
            </SwipeableProvider>
          </GridItem>
        </LayoutGrid>
      </section>
    </InverseHeader>
  );
};

export default WhyOuraExplore;
